import React, { useState } from "react";
import { Drawer, IconButton, Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab'
// import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

import { FiMenu } from "react-icons/fi";
import { CgClose } from "react-icons/cg";
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Profile from '../Home/Profile';
import About from '../AboutMe/About'
import Portfolio from "../Projects/Portfolio";
import Contact from "../ContactMe/Contact"


const MuiDrawer = () => {
  const [value, setValue] = useState('1')
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue)
    window.scrollTo(0,0);
}

const handleClick = (value) => {
  setValue(value)
  window.scrollTo(0,0);
}

  return (
    <React.Fragment>

        <TabContext value={value} sx={{ backgroundColor: '#088395'}}>
          <Box>
          <Drawer   open={openDrawer}
          onClose={() =>setOpenDrawer(false)}
          >
            <TabList
              onChange={handleChange}
              orientation='vertical'
              aria-label='Tabs example' 
              centered
              TabIndicatorProps={{sx: {backgroundColor: '#088395', height: 2}}}
              sx={{
                "& .MuiPaper-root": { backgroundColor: '#088395'},
                  "& button": { color: '#002d5b' },
                  "& button.Mui-selected": { borderRadius: '10px',color: "#088395", borderColor: "#088395"},
                  '& .MuiTabs-flexContainer': { flexWrap: 'wrap'},

              }}
              >
              <IconButton onClick={() =>setOpenDrawer(!openDrawer)}>
              <CgClose
              style={{ color: "#088395"}}
              />
            </IconButton>
              <Tab label='Home' value='1'/>
              <Tab label='About' value='2' />
              <Tab label='Projects' value='3' />
              <Tab label='Contact' value='4' />
            </TabList>
            </Drawer>
          </Box>
          <IconButton onClick={() =>setOpenDrawer(!openDrawer)}>
          <FiMenu
          style={{ color: "#088395"}}
          />
        </IconButton>
          <TabPanel value='1'>
            <Profile onClick={handleClick}/>
          </TabPanel>
          <TabPanel value='2'>
              <About />
          </TabPanel>
          <TabPanel value='3'>
              <Portfolio onClick={handleClick}/>
          </TabPanel>
          <TabPanel value='4'>
            <Contact />
          </TabPanel>
        </TabContext>




        
    </React.Fragment>
  )
}

export default MuiDrawer